/**
 * Break-glass: the "check everything before you book" paragraph, capped so its
 * lines stay readable inside the 1024px booking column.
 *
 * A measure cap on a block of copy has no ui-core expression — `Center` also
 * centres, and this copy is left-aligned with the rest of the column.
 */

import { T } from "@freightsimple/ui-core/Typography/T";

export function BookShipmentReviewIntroCopy() {
  return (
    <div className="max-w-[800px]">
      <T size="base" color="secondary">
        Please double-check all the details are correct before booking the
        shipment. Incorrect information may lead to additional charges from the
        carrier later, which you will be responsible for. Delivery dates are
        subject to change due to unforeseen delays.
      </T>
    </div>
  );
}
